import { auth } from "../config/firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, getAuth } from "firebase/auth"
import { useRef, useState } from "react"
import Button from "@mui/material/Button"
import { Alert, Box, Container, CssBaseline, Grid, InputAdornment, Snackbar, TextField } from "@mui/material";
import Typography from '@mui/material/Typography';
import Paper from "@mui/material/Paper";
import { Link, useNavigate } from 'react-router-dom';
import { TextDivider } from "./textDivider";
import EmailField from "./Controls/Fields/emailField";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import { FormControl } from "@mui/material/node";



export const Login = () => {
    const [show, setShow] = useState(true);
    const [errorOpen, setErrorOpen] = useState(false);
    const navigate = useNavigate();
    const emailRef = useRef();
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');

    const signIn = async (event) => {
        if (emailError || passwordError) {
            event.preventDefault();
            return;
        }
        
        const data = new FormData(event.currentTarget);
        console.log(data);

        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;

        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                navigate("/myprojects");
            })
            .catch((error) => {
                event.preventDefault();
                setErrorOpen(true);
                document.getElementById('email').value = "";
                document.getElementById('password').value = "";
                document.getElementById('email').focus();
            });
            event.preventDefault();
    }

    const signOut = async () => {
        try {
            await signOut(auth);
        }
        catch (err) {
            console.error(err);
        }
    }

    const validateInputs = () => {
        const email = document.getElementById('email');
        const password = document.getElementById('password');
    
        let isValid = true;
    
        if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
          setEmailError(true);
          setEmailErrorMessage('Please enter a valid email address.');
          isValid = false;
        } else {
          setEmailError(false);
          setEmailErrorMessage('');
        }
    
        if (!password.value || password.value.length < 6) {
          setPasswordError(true);
          setPasswordErrorMessage('Password must be at least 6 characters long.');
          isValid = false;
        } else {
          setPasswordError(false);
          setPasswordErrorMessage('');
        }
        return isValid;
      };

    if (!show) {
        return;
    }

    const handleClose = () => {
        setErrorOpen(false);
      };

    return (

        <Container component="main" maxWidth="lg">
            <Box
                sx={{
                    marginTop: 8,
                }}
            >
                <Grid container>
                    <CssBaseline />
                    <Grid
                        item
                        xs={false}
                        sm={4}
                        md={7}
                        sx={{
                            backgroundImage: "url(https://source.unsplash.com/random)",
                            backgroundRepeat: "no-repeat",
                            backgroundColor: (t) =>
                                t.palette.mode === "light"
                                    ? t.palette.grey[50]
                                    : t.palette.grey[900],
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    />
                    <Grid
                        item
                        xs={12}
                        sm={8}
                        md={5}
                        component={Paper}
                        elevation={6}
                        square
                    >
                        <Box
                            sx={{
                                my: 8,
                                mx: 4,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <Typography component="h1" variant="h6">
                                Welcome
                            </Typography>

                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                Continue with Google
                            </Button>

                            <Box
                                component="form"
                                noValidate
                                onSubmit={signIn}
                                sx={{ mt: 1 }}
                            >
                                <TextDivider text="or" />
                                <Typography variant="button" display="block" align="center" m={1} >
                                    Log into your account
                                </Typography>

                                <Typography align="center">
                                    Don't have a account yet? <Link href="#" variant="button">Sign Up!</Link>
                                </Typography>
                                <TextField id="email" label="Email Address" margin="normal"
                                    required
                                    fullWidth
                                    error={emailError}
                                    helperText={emailErrorMessage}
                                    autoComplete="email"
                                    type="email"
                                    autoFocus
                                    color={emailError ? 'error' : 'primary'}
                                    ref={emailRef}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EmailOutlinedIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField id="password" label="Password" margin="normal"
                                    required
                                    fullWidth
                                    error={passwordError}
                                    helperText={passwordErrorMessage}
                                    type="password"
                                    autoComplete="current-password"
                                    color={emailError ? 'error' : 'primary'}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LockOpenOutlinedIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}
                                    onClick={validateInputs}
                                >
                                    Login
                                </Button>
                                <Grid container >
                                    <Grid item xs align="right">
                                        <Link href="#" variant="body2" >
                                            Forgot password?
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Snackbar open={errorOpen} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    Wrong user name or password!
                </Alert>
            </Snackbar>
        </Container>
    )
}